import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { ShoppingBag, Wallet as WalletIcon, ClipboardList } from 'lucide-react';

export type CustomerTabType = 'shop' | 'wallet' | 'orders';

interface BottomNavProps {
  activeTab: CustomerTabType;
  onSelectTab: (tab: CustomerTabType) => void;
}

export const BottomNav: React.FC<BottomNavProps> = ({ activeTab, onSelectTab }) => {
  const { t } = useLanguage();

  const navItems = [
    { id: 'shop' as const, label: t.packages, icon: ShoppingBag },
    { id: 'wallet' as const, label: t.wallet, icon: WalletIcon },
    { id: 'orders' as const, label: t.orders, icon: ClipboardList },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-30 bg-surface-card/95 backdrop-blur-md border-t border-plum-border shadow-lg pb-safe">
      <div className="max-w-md mx-auto flex items-center justify-around h-16">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeTab === item.id;
          return (
            <button
              key={item.id}
              onClick={() => onSelectTab(item.id)}
              className={`flex flex-col items-center justify-center flex-1 h-full py-1 transition-colors touch-target ${
                isActive ? 'text-primary font-semibold' : 'text-plum-muted hover:text-plum-dark'
              }`}
            >
              <div className={`relative p-1 rounded-xl transition ${isActive ? 'bg-primary/15' : ''}`}>
                <Icon className={`w-5 h-5 ${isActive ? 'stroke-[2.5]' : 'stroke-2'}`} />
              </div>
              <span className="text-[11px] mt-0.5 leading-tight">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
